import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'flexibility_bundle';
export const route = 'flexibility_bundle/[bookingId]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/FlexibilityBundlePage')));